<p-confirmDialog key="timeschool" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstSchool"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedSchool"
		dataKey="SchoolID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--SchoolName-->
				<th>
					<p-columnFilter type="text" field="SchoolName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--TardyTime-->
				<th></th>

				<!--Update Button-->
				<th></th>
				<!--Clear Button-->
				<th></th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="SchoolName">School<p-sortIcon field="SchoolName"></p-sortIcon></th>
				<th pSortableColumn="TardyTime">Tardy Time<p-sortIcon field="TardyTime"></p-sortIcon></th>
				<th></th>
				<th></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-School>
			<tr [pSelectableRow]="School">
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ School[col.field] }}
				</td>

				<td>
					<p-calendar
						showIcon="true"
						showButtonBar="true"
						showTime="true"
						hourFormat="12"
						timeOnly="true"
						[(ngModel)]="School.TardyTimeDate"
						name="TardyTimeDate"
						appendTo="body"
					></p-calendar>
				</td>

				<td>
					<button class="btn btn-primary" (click)="onUpdate()">Set Time</button>
				</td>
				<td>
					<button class="btn btn-primary" (click)="onReset()">Reset Time</button>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
